import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, NgModule, OnInit, Output } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TakeOffMeasurement } from '../../domain';
import { PitchChangedEventArgs, TakeOffPitchDropdownModule } from '../../take-off/pitch-dropdown.component';
import { TakeOffConfig } from '../feat-take-off-v2/domain';
import { TakeOffDrawingColorPickerModule } from '../ui-take-off-drawing-color-picker/take-off-drawing-color-picker.component';

@Component({
    selector: 'app-take-off-drawing-actions',
    templateUrl: './take-off-drawing-actions.component.html',
    styleUrls: ['./take-off-drawing-actions.component.scss'],
    standalone: false,
})
export class TakeOffDrawingActionsComponent implements OnInit {
    // @ts-ignore TS2564
    @Input() config: TakeOffConfig;
    // @ts-ignore TS2564
    @Input() measurement: TakeOffMeasurement;

    @Output() centreChanges = new EventEmitter();
    @Output() shapeChanges = new EventEmitter<string>();
    @Output() colorChanges = new EventEmitter<string>();
    @Output() pitchChanges = new EventEmitter<PitchChangedEventArgs>();
    @Output() deductionChanges = new EventEmitter();
    @Output() toggleLabelChanges = new EventEmitter();

    constructor() {}

    ngOnInit(): void {}

    public onCenterCanvas() {
        this.centreChanges.emit();
    }

    public onChangeShape(shape: string) {
        this.shapeChanges.emit(shape);
    }

    public onColorChanged(color: string) {
        this.colorChanges.emit(color);
    }

    public pitchChanged(pitch: PitchChangedEventArgs) {
        this.pitchChanges.emit(pitch);
    }

    public onDeduct() {
        this.deductionChanges.emit();
    }

    public onToggleLabel() {
        this.toggleLabelChanges.emit();
    }
}

@NgModule({
    declarations: [TakeOffDrawingActionsComponent],
    imports: [CommonModule, TooltipModule, BsDropdownModule, TakeOffPitchDropdownModule, TakeOffDrawingColorPickerModule],
    exports: [TakeOffDrawingActionsComponent],
})
export class TakeOffDrawingActionsModule {}
